export const ProjectStatus = {
    ACTIVE: "ACTIVE",
    FINISHED: "FINISHED",
};
